module.exports = __webpack_public_path__ + "static/media/learning-15.a097f11e.png";